import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  getAllPageSuccess,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error,
  getAllPage,
} from './actions';

import { ServiceAIS } from '~/services/modulos/serviceAIS';
import { createSagaReutils, createAllTakeLastDefault } from '~/utils/reutils';

import ACTION from '../actionTypes';

const ACOES_DEFULT = createSagaReutils(
  `/ais`,
  ServiceAIS,
  getAllPage,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error
);

function* listPageableSaga({ params }) {
  try {
    const list = yield call(ServiceAIS.getAllPageable, params);
    yield put(getAllPageSuccess(list));
  } catch (e) {
    yield put(error(e));
  }
}

export default all([
  ...createAllTakeLastDefault({ modulo: 'AIS', ACOES: ACOES_DEFULT }),
  takeLatest(ACTION.AIS_GET_SEARCH_PAGE, listPageableSaga),
]);
